export function DateUtils() {
    let months = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran",
        "Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];
    this.getStrDate = function(timestamp){
        let dateNow = new Date();
        let date = new Date(timestamp*1000);

        let prefix;


        if(dateNow.getDate()===date.getDate() && dateNow.getMonth() === date.getMonth() && dateNow.getFullYear()===date.getFullYear())
            prefix = "Bugün";
        else if(dateNow.getDate()===date.getDate()+1 && dateNow.getMonth() === date.getMonth() && dateNow.getFullYear()===date.getFullYear())
            prefix = "Dün";
        else {
            prefix = date.getDate() + " " + (months[date.getMonth()]);

            if(dateNow.getFullYear()!==date.getFullYear()){
                prefix += " "+date.getFullYear()
            }
        }

        return prefix + " " + this.checkZero(date.getHours()) +":"+this.checkZero(date.getMinutes());
    };

    this.checkZero = function(s){
        if(s>9) return s;
        else return "0"+s;
    }
}